import { render, staticRenderFns } from "./AddProjectStep1.vue?vue&type=template&id=be8d61e0&scoped=true"
import script from "./AddProjectStep1.vue?vue&type=script&lang=js"
export * from "./AddProjectStep1.vue?vue&type=script&lang=js"
import style0 from "./AddProjectStep1.vue?vue&type=style&index=0&id=be8d61e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8d61e0",
  null
  
)

export default component.exports